import {
  AppAbility,
  type Actions,
  type Subjects,
  defineManagerAbilities,
  defineStaffMemberAbilities,
  defineUnassignedUserAbilities,
} from "./abilities";

export { useAbilities } from "./use-abilities";

export const AccessControl = {
  abilities: {
    unassigned: defineUnassignedUserAbilities(),
    staffMember: defineStaffMemberAbilities(),
    manager: defineManagerAbilities(),
  } satisfies Record<string, AppAbility>,
};

export type RoleAbility = AppAbility;
export type AppActions = Actions;
export type AppSubjects = Subjects;
